import axios from "./axios-auth";


const getBreakageReport = async () => {
    try {
        const resp = await axios({
            url: "/dv-adm/breakagereport",
            method: "GET",
        })

        if (resp.status !== 200) {
            throw new Error(resp.data.message);
        }

        return resp.data;
    }
    catch (e) {
        console.error(e)
    }

}

const getCardsAdvancedSearch = async () => {
    try {
        const resp = await axios({
            url: "/dv-adm/getCardsAdvancedSearch",
            method:"POST",
            data: {
                email: {},
              },
        })

        if (resp.status !== 200) {
            throw new Error(resp.data.message);
        }

        return resp.data;
    }
    catch (e) {
        console.error(e)
    }
}


export { getBreakageReport, getCardsAdvancedSearch }